// extracted by mini-css-extract-plugin
module.exports = {"teamImage":"TheMatchHeader_teamImage_JDoFr","teamNameText":"TheMatchHeader_teamNameText_b2xw7"};